var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',{staticClass:"container"},[_c('line-chart',{attrs:{"chart-data":_vm.data,"width":3000,"height":1000}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }